<template>
  <div class="WorkForm">
    <h3>合同上传</h3>
    <el-form ref="addworkForm" class="demo-form-inline" :model="addworkForm" :rules="rules" label-position="top">
      <el-form-item label="合同附件（PDF）" prop="attachment">
        <div class="attachment-upload-wrapper">
          <!-- OCR开关和提示信息行 -->
          <div class="ocr-control-row">
            <div class="ocr-switch-container">
              <el-switch
                v-model="ocrEnabled"
                active-color="#409EFF"
                inactive-color="#DCDFE6"
                :disabled="ocrStatusLoading"
                @change="handleOcrSwitchChange">
              </el-switch>
              <span class="ocr-switch-label">
                <i :class="ocrEnabled ? 'el-icon-check' : 'el-icon-close'" 
                   :style="{ color: ocrEnabled ? '#409EFF' : '#909399' }"></i>
                {{ ocrEnabled ? '启用OCR识别' : '关闭OCR识别' }}
              </span>
            </div>
            <div class="ocr-tip">
              <i class="el-icon-info"></i>
              <span>{{ ocrEnabled ? '上传PDF后将自动识别并提取信息' : '上传PDF后不会进行OCR识别' }}</span>
            </div>
          </div>
          
          <!-- 文件上传区域 -->
          <div class="upload-area">
            <el-upload 
              class="upload-demo" 
              ref="upload" 
              action="#" 
              :auto-upload="false" 
              :on-change="handleAttachmentChange"
              :on-remove="handleAttachmentRemove" 
              :before-upload="beforeAttachmentUpload" 
              :file-list="attachmentFiles"
              :limit="1" 
              accept=".pdf">
              <el-button size="medium" type="primary" icon="el-icon-upload">
                选择PDF文件
              </el-button>
              <div slot="tip" class="el-upload__tip">
                <i class="el-icon-document"></i>
                只能上传PDF文件，且不超过30MB
              </div>
            </el-upload>
          </div>
        </div>
      </el-form-item>
      <!-- 序号 -->
      <!-- <el-form-item label="序号" prop="number">
        <el-input type="number" placeholder="请输入序号" v-model.number="addworkForm.number">
        </el-input>
      </el-form-item> -->

      <!-- 归档编号/报告号 -->
      <el-form-item label="归档编号/报告号" prop="ReturnId">
        <el-input type="text" placeholder="请输入归档编号/报告号" v-model="addworkForm.ReturnId">
        </el-input>
      </el-form-item>

      <!-- 服务内容 -->
      <el-form-item prop="content">
        <span slot="label">
          服务内容
          <el-tooltip content="上传PDF后可自动识别并匹配" placement="top">
            <i class="el-icon-info" style="color: #409EFF; margin-left: 5px; cursor: pointer;"></i>
          </el-tooltip>
        </span>
        <el-select v-model="addworkForm.content" placeholder="请选择服务内容（上传PDF后可自动匹配）" style="display: block" filterable>
          <el-option
            v-for="item in ServiceContentList"
            :key="item.id"
            :label="item.ContentName"
            :value="item.ContentName"
          ></el-option>
        </el-select>
      </el-form-item>


      <!-- 承接单位（用原来的SubjectId字段） -->
      <el-form-item prop="SubjectId">
        <span slot="label">
          承接单位
          <el-tooltip content="上传PDF后可自动识别并匹配" placement="top">
            <i class="el-icon-info" style="color: #409EFF; margin-left: 5px; cursor: pointer;"></i>
          </el-tooltip>
        </span>
        <el-select v-model="addworkForm.SubjectId" placeholder="请选择承接单位（上传PDF后可自动匹配）" style="display: block">
          <template v-for="subject in SubjectList">
            <el-option :label="subject.SubjectName" :value="subject.id" :key="subject.id"></el-option>
          </template>
        </el-select>
      </el-form-item>

      <!-- 建设单位（替换原来的 el-input） -->
      <el-form-item prop="build_company">
        <span slot="label">
          建设单位
          <el-tooltip content="上传PDF后可自动识别并填充" placement="top">
            <i class="el-icon-info" style="color: #409EFF; margin-left: 5px; cursor: pointer;"></i>
          </el-tooltip>
        </span>
        <el-autocomplete v-model="addworkForm.build_company" :fetch-suggestions="queryBuildCompanySuggestions"
          placeholder="请输入建设单位（上传PDF后可自动识别）" @select="handleBuildCompanySelect" style="width: 100%" clearable size="medium">
          <!-- 显示建议项的模板 -->
          <template slot-scope="{ item }">
            <div>{{ item.value }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>

      <!-- 中标/送审单位（替换原来的 el-input） -->
      <el-form-item label="中标/送审单位" prop="win_company">
        <el-autocomplete v-model="addworkForm.win_company" :fetch-suggestions="queryWinCompanySuggestions"
          placeholder="请输入中标/送审单位" @select="handleWinCompanySelect" style="width: 100%" clearable size="medium">
          <template slot-scope="{ item }">
            <div>{{ item.value }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>

      <!-- 项目名称 -->
      <el-form-item prop="WorkName">
        <span slot="label">
          项目名称
          <el-tooltip content="上传PDF后可自动识别并填充" placement="top">
            <i class="el-icon-info" style="color: #409EFF; margin-left: 5px; cursor: pointer;"></i>
          </el-tooltip>
        </span>
        <el-input type="text" placeholder="请输入项目名称（上传PDF后可自动识别）" v-model="addworkForm.WorkName">
        </el-input>
      </el-form-item>

      <!-- 招标控制价/审定价 -->
      <el-form-item label="招标控制价/审定价（元）" prop="FirstPrice">
        <el-input type="number" placeholder="请输入招标控制价/审定价" v-model.number="addworkForm.FirstPrice" step="0.01">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 中标价/送审价 -->
      <el-form-item label="中标价/送审价（元）" prop="SecondPrice">
        <el-input type="number" placeholder="请输入中标价/送审价" v-model.number="addworkForm.SecondPrice" step="0.01">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 评委费 -->
      <el-form-item label="评委费（元）" prop="PingPrice">
        <el-input type="number" placeholder="请输入评委费" v-model.number="addworkForm.PingPrice" step="0.01">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 已开票金额 -->
      <el-form-item label="已开票金额（元）" prop="PayPrice">
        <el-input type="number" placeholder="请输入已开票金额" v-model.number="addworkForm.PayPrice" step="0.01">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 截止时间 -->
      <el-form-item label="截止时间" prop="DeadLine">
        <el-date-picker type="date" placeholder="选择日期" v-model="addworkForm.DeadLine" style="width: 100%"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>

      <el-form-item label="备注" prop="note">
        <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="addworkForm.note"
          maxlength="2000" show-word-limit>
        </el-input>
      </el-form-item>

      <!-- 抄送人：仅管理员、部门经理 -->
      <el-form-item v-if="canSetCc" label="抄送人" prop="ccUserIds">
        <cc-user-select
          v-model="addworkForm.ccUserIds"
          :options="ccCandidates"
          :loading="ccLoading"
          placeholder="按姓名 / 工号 / 部门搜索"
        />
      </el-form-item>

      <!-- 合同金额，可以放在截止时间前面 -->
      <el-form-item prop="HtPrice">
        <span slot="label">
          合同金额（元）
          <el-tooltip content="上传PDF后可自动识别并填充" placement="top">
            <i class="el-icon-info" style="color: #409EFF; margin-left: 5px; cursor: pointer;"></i>
          </el-tooltip>
        </span>
        <el-input type="number" placeholder="请输入合同金额（上传PDF后可自动识别）" v-model.number="addworkForm.HtPrice" step="0.01">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="confirmAdd" style="width:100%" :loading="loading">
          添加</el-button>
      </el-form-item>
    </el-form>
    
    <!-- OCR识别进度提示（非阻塞浮动提示框） -->
    <transition name="fade">
      <div v-if="showOcrLoading" class="ocr-loading-floating">
        <div class="ocr-loading-content">
          <div class="ocr-loading-icon-wrapper">
            <div class="ocr-loading-circle">
              <i class="el-icon-loading"></i>
            </div>
          </div>
          <div class="ocr-loading-text">
            <h3 class="ocr-loading-title">正在识别PDF文件</h3>
            <p class="ocr-loading-desc">系统正在提取合同信息，您可以继续填写其他字段</p>
            <p v-if="ocrProgress" class="ocr-loading-progress">
              <i class="el-icon-time"></i>
              {{ ocrProgress }}
            </p>
          </div>
        </div>
      </div>
    </transition>
    
    <!-- OCR结果确认弹窗 -->
    <el-dialog
      title="OCR识别结果"
      :visible.sync="showOcrDialog"
      width="600px"
      :close-on-click-modal="false">
      <div class="ocr-result">
        <p style="margin-bottom: 15px; color: #606266;">系统已从PDF中提取以下信息，是否使用这些信息填充表单？</p>
        <el-table :data="ocrResultTable" border size="small" style="width: 100%">
          <el-table-column prop="field" label="字段" width="120"></el-table-column>
          <el-table-column prop="value" label="提取的值">
            <template slot-scope="scope">
              <span v-if="scope.row.value" style="color: #409EFF;">{{ scope.row.value }}</span>
              <span v-else style="color: #909399;">未提取到</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showOcrDialog = false">取消</el-button>
        <el-button type="primary" @click="applyOcrResult">使用OCR结果</el-button>
      </span>
    </el-dialog>

    <!-- 同名项目确认弹窗 -->
    <el-dialog
      title="发现同名项目"
      :visible.sync="showDuplicateDialog"
      width="720px"
      :close-on-click-modal="false">
      <div class="duplicate-tip">
        <i class="el-icon-warning" style="color: #E6A23C; margin-right: 6px;"></i>
        系统中已存在项目名称与「{{ addworkForm.WorkName }}」一致的合同，请确认是否仍要继续上传。
      </div>
      <el-table :data="duplicateContracts" border size="small" style="width: 100%; margin-top: 12px;" max-height="360">
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column prop="WorkName" label="项目名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="build_company" label="建设单位" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="SubjectName" label="承接单位" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="服务内容" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ReturnId" label="归档编号" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column label="截止时间" width="110" align="center">
          <template slot-scope="scope">{{ formatDuplicateDate(scope.row.DeadLine) }}</template>
        </el-table-column>
        <el-table-column prop="create_user_name" label="上传人" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.is_completed == 1 ? 'success' : 'info'">
              {{ scope.row.is_completed == 1 ? '已完成' : '未完成' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDuplicateDialog = false">取消上传</el-button>
        <el-button type="warning" :loading="loading" @click="continueDespiteDuplicate">仍要继续上传</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 合同附件上传区域样式 */
.attachment-upload-wrapper {
  width: 100%;
}

.ocr-control-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #f0f2f5 100%);
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
}

.ocr-control-row:hover {
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
  border-color: #c0c4cc;
}

.ocr-switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ocr-switch-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  transition: color 0.3s ease;
}

.ocr-switch-label i {
  font-size: 16px;
  font-weight: bold;
}

.ocr-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #909399;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  transition: all 0.3s ease;
}

.ocr-tip i {
  font-size: 14px;
  color: #409EFF;
}

.ocr-tip:hover {
  background: rgba(255, 255, 255, 1);
  color: #606266;
}

.upload-area {
  padding: 16px;
  background: #ffffff;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.upload-area:hover {
  border-color: #409EFF;
  background: #fafbfc;
}

.upload-demo {
  width: 100%;
}

.upload-demo .el-upload {
  width: 100%;
}

.upload-demo .el-button {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
  transition: all 0.3s ease;
}

.upload-demo .el-button:hover {
  box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
  transform: translateY(-1px);
}

.el-upload__tip {
  margin-top: 12px;
  font-size: 13px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 6px;
}

.el-upload__tip i {
  font-size: 14px;
  color: #409EFF;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .ocr-control-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .ocr-tip {
    width: 100%;
    justify-content: center;
  }
}
</style>

<style>
/* OCR加载浮动提示框样式 - 完全不阻挡操作 */
.ocr-loading-floating {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 380px;
  z-index: 3000;
  pointer-events: none; /* 关键：不阻挡任何点击事件 */
}

.ocr-loading-floating * {
  pointer-events: auto; /* 但内容本身可以显示和交互 */
}

/* 淡入淡出动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* OCR加载内容样式 */
.ocr-loading-content {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 30px 25px;
  color: #fff;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.ocr-loading-icon-wrapper {
  margin-bottom: 20px;
}

.ocr-loading-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: pulse 2s ease-in-out infinite;
}

.ocr-loading-circle i {
  font-size: 32px;
  color: #fff;
  animation: rotating 1.5s linear infinite;
}

.ocr-loading-text {
  color: #fff;
}

.ocr-loading-title {
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
}

.ocr-loading-desc {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

.ocr-loading-progress {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.ocr-loading-progress i {
  font-size: 14px;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(255, 255, 255, 0);
  }
}

/* 确保label和提示图标在同一行 */
.el-form-item__label span {
  display: inline;
  white-space: nowrap;
}

.duplicate-tip {
  color: #606266;
  line-height: 1.6;
  font-size: 14px;
}
</style>

<script>
import { initSubject, initServiceContent, addwork, checkWorkName, getCompanyHistory, ocrPdf, getOcrStatus, getCcCandidates } from "../api";
import { mapGetters } from "vuex";
import CcUserSelect from "./CcUserSelect.vue";
export default {
  name: "WorkForm",
  components: { CcUserSelect },
  computed: {
    ...mapGetters(["name", "roleId"]),
    canSetCc() {
      return this.roleId == 1 || this.roleId == 4;
    }
  },
  data() {
    return {
      loading: false,
      ifSmall: false,
      SubjectList: [],  // 承接单位列表
      ServiceContentList: [],  // 服务内容列表
      attachmentFiles: [], // 上传的文件列表
      attachmentFile: null, // 当前选择的文件
      showOcrDialog: false, // 显示OCR结果弹窗
      showOcrLoading: false, // 显示OCR加载中弹窗
      showDuplicateDialog: false, // 同名项目确认弹窗
      duplicateContracts: [], // 同名项目列表
      ocrResult: null, // OCR提取的结果
      ocrResultTable: [], // OCR结果表格数据
      ocrProgress: '', // OCR进度提示
      ocrEnabled: true, // OCR开关状态（前端控制）
      ocrStatusLoading: false, // 加载OCR状态中
      ocrProcessing: false, // OCR正在处理中，防止重复调用
      paginationLayout: "prev, pager,next, jumper, ->, total, sizes",
      ccCandidates: [],
      ccLoading: false,
      addworkForm: {
        // number: "",          // 序号
        ReturnId: "",        // 归档编号/报告号
        content: "",         // 服务内容
        build_company: "",   // 建设单位
        SubjectId: "",       // 承接单位（用原来的SubjectId字段）
        win_company: "",     // 中标单位
        DeadLine: "",        // 截止时间
        WorkName: "",        // 项目名称
        FirstPrice: null,    // 招标控制价/审定价
        SecondPrice: null,   // 中标价/送审价
        PingPrice: null,     // 评委费
        PayPrice: null,      // 已开票金额
        buildCompanySuggestions: [],  // 建设单位建议列表
        winCompanySuggestions: [],    // 中标单位建议列表
        note: "",          // 新增：备注
        HtPrice: null,     // 新增：合同金额
        ccUserIds: [],     // 抄送人
      },
      rules: {
        // number: [
        //   { required: true, message: "请输入序号", trigger: "blur" }
        // ],
        content: [
          { required: true, message: "请选择服务内容", trigger: "change" }
        ],
        build_company: [
          { required: true, message: "请输入建设单位", trigger: "blur" }
        ],
        SubjectId: [  // 承接单位验证（保持原来的字段名）
          { required: true, message: "请选择承接单位", trigger: "change" }
        ],
        DeadLine: [
          { required: true, message: "请选择截止时间", trigger: "change" }
        ],
        WorkName: [
          { required: true, message: "请输入项目名称", trigger: "blur" }
        ]
      },
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    canSetCc: {
      immediate: false,
      handler(val) {
        if (val && (!this.ccCandidates || this.ccCandidates.length === 0)) {
          this.loadCcCandidates();
        }
      }
    }
  },
  methods: {
    init() {
      // 获取承接单位列表（原来的课程列表）
      initSubject()
        .then((res) => {
          let obj = JSON.parse(res.msg);
          this.SubjectList = obj.Subject;
        })
        .catch((failResponse) => { });

      // 获取服务内容列表
      initServiceContent()
        .then((res) => {
          let obj = JSON.parse(res.msg);
          this.ServiceContentList = obj.ServiceContent || [];
        })
        .catch((failResponse) => { });
      
      // 获取OCR开关状态
      this.getOcrStatus();

      // 管理员/部门经理加载抄送候选人
      if (this.canSetCc) {
        this.loadCcCandidates();
      }
    },

    loadCcCandidates() {
      this.ccLoading = true;
      getCcCandidates()
        .then((res) => {
          if (res.code === 0) {
            this.ccCandidates = res.data || [];
          }
        })
        .catch(() => {})
        .finally(() => {
          this.ccLoading = false;
        });
    },
    
    // 获取OCR开关状态
    getOcrStatus() {
      this.ocrStatusLoading = true;
      getOcrStatus()
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.ocrEnabled = res.data.enabled !== false; // 默认true
          }
        })
        .catch((error) => {
          console.error('获取OCR状态失败:', error);
          // 失败时默认开启
          this.ocrEnabled = true;
        })
        .finally(() => {
          this.ocrStatusLoading = false;
        });
    },
    
    // OCR开关变化处理
    handleOcrSwitchChange(value) {
      console.log('OCR开关状态:', value ? '开启' : '关闭');
    },

    formatDuplicateDate(dateStr) {
      if (!dateStr) return '-';
      const s = String(dateStr);
      return s.length >= 10 ? s.substring(0, 10) : s;
    },

    // 确认添加：先校验表单，再查同名项目
    confirmAdd() {
      this.$refs.addworkForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.checkDuplicateThenSubmit();
      });
    },

    async checkDuplicateThenSubmit() {
      this.loading = true;
      try {
        const res = await checkWorkName({ WorkName: (this.addworkForm.WorkName || '').trim() });
        this.loading = false;
        if (res.code === 0 && Array.isArray(res.data) && res.data.length > 0) {
          this.duplicateContracts = res.data;
          this.showDuplicateDialog = true;
          return;
        }
        this.doSubmit();
      } catch (error) {
        console.error('检查同名项目失败:', error);
        this.loading = false;
        this.$message({
          message: "检查同名项目失败，请重试",
          type: "error",
        });
      }
    },

    continueDespiteDuplicate() {
      this.showDuplicateDialog = false;
      this.doSubmit();
    },

    // 实际上传提交
    doSubmit() {
      let _this = this;
      _this.loading = true;

      try {
        const formData = new FormData();

        formData.append("number", this.addworkForm.number);
        formData.append("ReturnId", this.addworkForm.ReturnId || "");
        formData.append("content", this.addworkForm.content);
        formData.append("build_company", this.addworkForm.build_company);
        formData.append("receive_companyId", this.addworkForm.SubjectId);
        formData.append("win_company", this.addworkForm.win_company || "");
        formData.append("DeadLine", this.addworkForm.DeadLine);
        formData.append("WorkName", this.addworkForm.WorkName);

        if (this.addworkForm.FirstPrice !== null) {
          formData.append("FirstPrice", this.addworkForm.FirstPrice);
        }
        if (this.addworkForm.SecondPrice !== null) {
          formData.append("SecondPrice", this.addworkForm.SecondPrice);
        }
        if (this.addworkForm.PingPrice !== null) {
          formData.append("PingPrice", this.addworkForm.PingPrice);
        }
        if (this.addworkForm.PayPrice !== null) {
          formData.append("PayPrice", this.addworkForm.PayPrice);
        }
        if (this.addworkForm.note !== undefined) {
          formData.append("note", this.addworkForm.note);
        }
        if (this.addworkForm.HtPrice !== null) {
          formData.append("HtPrice", this.addworkForm.HtPrice);
        }
        if (this.canSetCc && this.addworkForm.ccUserIds && this.addworkForm.ccUserIds.length) {
          formData.append("ccUserIds", this.addworkForm.ccUserIds.join(","));
        }

        if (this.attachmentFile) {
          const file = this.attachmentFile.raw || this.attachmentFile;
          formData.append("attachment", file);
        }

        addwork(formData)
          .then((res) => {
            if (res.code === 0) {
              _this.$message({
                message: res.msg,
                type: "success",
              });
              _this.loading = false;
              _this.$router.push("/yj/work");
            } else {
              _this.$message({
                message: res.msg,
                type: "error",
              });
              _this.loading = false;
            }
          })
          .catch((error) => {
            console.error('请求失败:', error);
            _this.$message({
              message: "添加失败，请重试",
              type: "error",
            });
            _this.loading = false;
          });
      } catch (error) {
        console.error('提交异常:', error);
        _this.loading = false;
        _this.$message({
          message: "添加失败，请重试",
          type: "error",
        });
      }
    },

    // 建设单位搜索建议
    async queryBuildCompanySuggestions(queryString, callback) {
      try {
        let params = new URLSearchParams();
        params.append("type", "build");  // 类型：建设单位
        if (queryString) {
          params.append("keyword", queryString);
        }

        const res = await getCompanyHistory(params);
        if (res.code === 0) {
          // 把返回的公司名数组转换成 el-autocomplete 需要的格式
          const suggestions = res.data.map(company => ({
            value: company  // 必须要有 value 字段
          }));
          callback(suggestions);  // 传给组件显示
        } else {
          callback([]);
        }
      } catch (error) {
        console.error('获取建设单位历史失败:', error);
        callback([]);
      }
    },

    // 中标单位搜索建议
    async queryWinCompanySuggestions(queryString, callback) {
      try {
        let params = new URLSearchParams();
        params.append("type", "win");  // 类型：中标单位
        if (queryString) {
          params.append("keyword", queryString);
        }

        const res = await getCompanyHistory(params);
        if (res.code === 0) {
          const suggestions = res.data.map(company => ({
            value: company
          }));
          callback(suggestions);
        } else {
          callback([]);
        }
      } catch (error) {
        console.error('获取中标单位历史失败:', error);
        callback([]);
      }
    },

    // 建设单位选择
    handleBuildCompanySelect(item) {
      this.addworkForm.build_company = item.value;
    },

    // 中标单位选择
    handleWinCompanySelect(item) {
      this.addworkForm.win_company = item.value;
    },

    handleAttachmentChange(file, fileList) {
      console.log('文件选择变化:', file, fileList);
      if (fileList.length > 1) {
        fileList.splice(0, 1); // 只保留最后一个文件
      }
      this.attachmentFile = file;
      this.attachmentFiles = fileList;
      
      // 选择PDF后立即上传并OCR（如果OCR开关开启且未在处理中）
      if (file && file.raw && this.ocrEnabled && !this.ocrProcessing) {
        // 防止重复调用
        this.ocrProcessing = true;
        
        const formData = new FormData();
        formData.append("file", file.raw);
        
        console.log('开始上传PDF并OCR识别...');
        
        // 显示加载弹窗
        this.showOcrLoading = true;
        this.ocrProgress = '正在上传文件...';
        
        ocrPdf(formData)
          .then((res) => {
            // 关闭加载弹窗
            this.showOcrLoading = false;
            this.ocrProgress = '';
            this.ocrProcessing = false; // 重置处理状态
            
            if (res.code === 0 && res.data) {
              console.log('OCR识别成功:', res.data);
              // 保存OCR结果
              this.ocrResult = res.data;
              // 构建表格数据
              this.buildOcrResultTable();
              // 显示结果弹窗
              this.showOcrDialog = true;
            } else {
              console.error('OCR识别失败:', res.msg);
              this.$message({
                message: 'OCR识别失败: ' + (res.msg || '未知错误'),
                type: 'warning',
                duration: 3000
              });
            }
          })
          .catch((error) => {
            // 关闭加载弹窗
            this.showOcrLoading = false;
            this.ocrProgress = '';
            this.ocrProcessing = false; // 重置处理状态
            
            console.error('OCR请求失败:', error);
            this.$message({
              message: 'OCR识别请求失败: ' + (error.message || '网络错误'),
              type: 'error',
              duration: 3000
            });
          });
      } else if (file && file.raw && !this.ocrEnabled) {
        // OCR关闭时，只保存文件，不进行识别
        console.log('OCR功能已关闭，跳过识别');
      }
    },

    handleAttachmentRemove() {
      console.log('文件被移除');
      this.attachmentFile = null;
      this.attachmentFiles = [];
      // 重置OCR处理状态
      this.ocrProcessing = false;
      this.showOcrLoading = false;
      this.ocrProgress = '';
    },

    beforeAttachmentUpload(file) {
      console.log('上传前验证:', file);
      const isPDF = file.type === 'application/pdf';
      const isLt30M = file.size / 1024 / 1024 < 30;

      if (!isPDF) {
        this.$message.error('只能上传PDF格式的文件!');
        return false;
      }
      if (!isLt30M) {
        this.$message.error('文件大小不能超过30MB!');
        return false;
      }
      return true;
    },
    
    // 构建OCR结果表格数据
    buildOcrResultTable() {
      this.ocrResultTable = [
        { field: '服务内容', value: this.ocrResult.content, key: 'content' },
        { field: '建设单位', value: this.ocrResult.buildCompany, key: 'buildCompany' },
        { field: '项目名称', value: this.ocrResult.workName, key: 'workName' },
        { field: '承接单位', value: this.ocrResult.receiveCompany, key: 'receiveCompany' },
        { field: '合同金额', value: this.ocrResult.contractAmount, key: 'contractAmount' }
      ];
    },
    
    // 应用OCR结果到表单
    applyOcrResult() {
      if (!this.ocrResult) {
        return;
      }
      
      // 填充服务内容（需要匹配下拉列表）
      if (this.ocrResult.content) {
        const matchedContent = this.findMatchingServiceContent(this.ocrResult.content);
        if (matchedContent) {
          this.addworkForm.content = matchedContent.ContentName;
        } else {
          this.$message({
            message: '服务内容"' + this.ocrResult.content + '"未在列表中找到，请手动选择',
            type: 'warning',
            duration: 3000
          });
        }
      }
      
      // 填充建设单位
      if (this.ocrResult.buildCompany) {
        this.addworkForm.build_company = this.ocrResult.buildCompany;
      }
      
      // 填充项目名称
      if (this.ocrResult.workName) {
        this.addworkForm.WorkName = this.ocrResult.workName;
      }
      
      // 填充承接单位（需要匹配下拉列表）
      if (this.ocrResult.receiveCompany) {
        const matchedSubject = this.findMatchingSubject(this.ocrResult.receiveCompany);
        if (matchedSubject) {
          this.addworkForm.SubjectId = matchedSubject.id;
        } else {
          // 如果没有匹配到，提示用户手动选择
          this.$message({
            message: '承接单位"' + this.ocrResult.receiveCompany + '"未在列表中找到，请手动选择',
            type: 'warning',
            duration: 3000
          });
        }
      }
      
      // 填充合同金额
      if (this.ocrResult.contractAmount) {
        const amount = parseFloat(this.ocrResult.contractAmount);
        if (!isNaN(amount)) {
          this.addworkForm.HtPrice = amount;
        }
      }
      
      // 关闭弹窗
      this.showOcrDialog = false;
      
      this.$message({
        message: 'OCR结果已应用到表单',
        type: 'success',
        duration: 2000
      });
    },
    
    // 在承接单位列表中查找匹配项
    findMatchingSubject(ocrText) {
      if (!ocrText || !this.SubjectList || this.SubjectList.length === 0) {
        return null;
      }
      
      // 清理OCR文本
      const cleanText = ocrText.trim().replace(/[：:（()）]/g, '');
      
      // 精确匹配
      for (let subject of this.SubjectList) {
        if (subject.SubjectName && subject.SubjectName.trim() === cleanText) {
          return subject;
        }
      }
      
      // 包含匹配
      for (let subject of this.SubjectList) {
        if (subject.SubjectName && (
          subject.SubjectName.includes(cleanText) || 
          cleanText.includes(subject.SubjectName)
        )) {
          return subject;
        }
      }
      
      return null;
    },

    // 在服务内容列表中查找匹配项
    findMatchingServiceContent(ocrText) {
      if (!ocrText || !this.ServiceContentList || this.ServiceContentList.length === 0) {
        return null;
      }

      const cleanText = ocrText.trim().replace(/[：:（()）]/g, '');

      for (let item of this.ServiceContentList) {
        if (item.ContentName && item.ContentName.trim() === cleanText) {
          return item;
        }
      }

      for (let item of this.ServiceContentList) {
        if (item.ContentName && (
          item.ContentName.includes(cleanText) ||
          cleanText.includes(item.ContentName)
        )) {
          return item;
        }
      }

      return null;
    },
  },
};
</script>